<div class="sidebar" role="dialog">
	<app-sidebar-header *ngIf="flight"
		[departureCity]="this.INDRA_getLocation(INDRA_getFirstSegmentFlight(this.flight.listSegment).departureAirport)?.city"
		[arrivalCity]="this.INDRA_getLocation(INDRA_getLastSegmentFlight(this.flight.listSegment).arrivalAirport)?.city"
		[label]="INDRA_printLabel()">
	</app-sidebar-header>
	
	<app-loading *ngIf="isFlightInfoLoading"></app-loading>

	<div class="sidebar__body sl--scrollable low-contrast" #sidebar__body
		style="height: calc(100% - 60px); overflow: auto" *ngIf="flight && !isFlightInfoLoading">
        
		<div class="plane-image hidden-mobile" *ngIf="INDRA_hasNoStops() && INDRA_isTAPFlight() && INDRA_getPlaneImage()">
			<img src="{{INDRA_getPlaneImage()}}">
		</div>
		
		<app-flight-details [flight]="INDRA_getFlightDetails()" [summaryMode]="true" class="flight-header"></app-flight-details>
		
		<div class="flight-timeline">
			
			<div class="timeline-item flight-airport-departure">
                <div class="flight-time">{{ INDRA_printDatetime(flight.listSegment[0].departureDate) }}</div>
                <div class="flight-airport">
					<span class="code">
						{{flight.listSegment[0].departureAirport}}
					</span> 
					&mdash;
					{{INDRA_getLocation(flight.listSegment[0].departureAirport)?.name}}
				</div>
                <div class="flight-gate" *ngIf="INDRA_hasTerminal(flight.listSegment[0].departureTerminal,0,0)">	
					{{ INDRA_getEquipmentTypeTranslation(flight.listSegment[0].departureTerminal,0,0) | ibeadmin:'sync'}} 
					{{ INDRA_getTerminal(flight.listSegment[0].departureTerminal,0,0) | ibeadmin:'sync' }}
				</div>
				<div class="flight-gate" *ngIf="!INDRA_hasTerminal(flight.listSegment[0].departureTerminal,0,0)"> <br> </div>
			</div>
			
			
			<div *ngFor="let segment of flight.listSegment; let i = index">
				
				<div class="timeline-item flight-plane-departure">
					<div class="flight-number">{{ segment.carrier}} {{segment.flightNumber.padStart(4, '0') }}</div>
					<span *ngIf="INDRA_showInfo(i)" class="flight-note">
						<app-svg class="flight-note__icon" svg="icons.svg#general--information" alt="Information icon"
							aria-hidden="true" [tooltip]="INDRA_getTextTranslation('tapGuarantee', 'title') | ibeadmin:'sync'"></app-svg> 
							{{INDRA_getTextTranslation('subjectToApproval') | ibeadmin:'sync'}}
					</span>
                    <div class="flight-duration">{{ INDRA_getDuration(i) }}</div>
                    <div class="flight-details">
						{{ INDRA_getAirplaneModel(segment.equipment) | ibeadmin:'sync'}} 
						<ng-container *ngIf="!INDRA_isNonPlaneEquipment(segment)">
							&mdash;
							{{INDRA_getTextTranslation('OperatedBy') | ibeadmin:'sync'}}
							{{ INDRA_getAirplaneName(airLines[i]) }} 
						</ng-container>
					</div>
				</div>
				
				<div class="timeline-item-commercial flight-airport-stop-commercial stop-end-commercial" *ngIf="INDRA_hasTechnicalStop(segment)">
					<div class="flight-time-commercial">
						{{'bookingDetails.text.stop' | ibeadmin | async}}
					</div>
					<div class="warning-commercial">
							{{INDRA_getTextTranslation('technicalStop') | ibeadmin:'sync'}} {{ INDRA_getTechnicalStop(segment)?.city }} {{ 'bookingDetails.text.withoutChangingPlane' | ibeadmin | async }}
					</div>
					<div class="flight-gate-commercial">
						{{ 'bookingDetails.text.durationStop' | ibeadmin | async }}: {{ INDRA_getDurationCommercial(segment) }}
					</div>
				</div>
				
				<div class="timeline-item flight-airport-stop stop-end" *ngIf="INDRA_isStopFlight(i)">
					<div class="flight-time">{{ INDRA_printDatetime(segment.arrivalDate) }}</div>
					<div class="flight-airport">
						<span class="code">{{ segment.arrivalAirport}}</span> &mdash;
						{{INDRA_getLocation(segment.arrivalAirport)?.name }}
					</div>
					<div class="flight-gate" *ngIf="INDRA_hasTerminal(segment.arrivalTerminal, i, 1)">
						{{ INDRA_getEquipmentTypeTranslation(segment.arrivalTerminal, i, 1) | ibeadmin:'sync'}} 
						{{ INDRA_getTerminal(segment.arrivalTerminal, i, 1)}}</div>
					<div class="flight-gate" *ngIf="!INDRA_hasTerminal(segment.arrivalTerminal, i, 1)"><br></div>
				</div>
				
				<div class="timeline-item-commercial flight-airport-stop-commercial stop-end-commercial" *ngIf="INDRA_isStopFlight(i)">
					<div class="layover-title">{{INDRA_getTextTranslation('transfer') | ibeadmin:'sync'}}</div>
					<div>{{INDRA_getTextTranslation(INDRA_getChangeTranslation(i)) | ibeadmin:'sync'}}</div>
					<div *ngIf="!INDRA_isLongLayover(i); else longLayover">
						{{INDRA_getTextTranslation('transferTime') | ibeadmin:'sync'}}:
						{{ INDRA_getLayoverDuration(i) }}
					</div>
					<ng-template #longLayover>
						<div>
							{{INDRA_getTextTranslation('longLayover') | ibeadmin:'sync'}}
							{{ INDRA_getLayoverDuration(i) }}
						</div>
					</ng-template>
					<div class="warning" *ngIf="INDRA_showAirportChangeWarning(i)">
						<app-svg class="warning-icon" svg="icons.svg#general--information" alt="Information icon" aria-hidden="true"
							[tooltip]="'you will land and depart from different airports'">
						</app-svg>
						{{INDRA_getTextTranslation('airportChangeWillDepart') | ibeadmin:'sync'}}
					</div>
				</div>
				
				<div class="timeline-item flight-airport-stop stop-end" *ngIf="INDRA_isStopFlight(i)">
					<div class="flight-time">{{ INDRA_printDatetime(flight.listSegment[i + 1].departureDate) }}</div>
					<div class="flight-airport">
						<span class="code">{{ flight.listSegment[i + 1].departureAirport}}</span> &mdash;
						{{INDRA_getLocation(flight.listSegment[i + 1].departureAirport)?.name}}
					</div>
					<div class="flight-gate" *ngIf="INDRA_hasTerminal(flight.listSegment[i + 1].departureTerminal, i, 2)"> 
						{{ INDRA_getEquipmentTypeTranslation(flight.listSegment[i + 1].departureTerminal, i, 2) | ibeadmin:'sync' | ibeadmin:'sync'}} 
						{{ INDRA_getTerminal(flight.listSegment[i + 1].departureTerminal, i, 2)}}
					</div>
					<div class="flight-gate" *ngIf="!INDRA_hasTerminal(flight.listSegment[i + 1].departureTerminal, i, 2)"><br></div>
				</div>
				
			</div>
			
			<div class="timeline-item flight-airport-arrival">
                <div class="flight-time">{{ INDRA_printDatetime(INDRA_getArrivalTime()) }}</div>
                <div class="flight-airport">
					<span class="code">{{ INDRA_getArrivalAirport()}}</span> &mdash;
					{{INDRA_getLocation(INDRA_getArrivalAirport())?.name}}
				</div>
                <div *ngIf="INDRA_hasArrivalTerminal()" class="flight-gate">
					{{ INDRA_getArrivalEquipmentTypeTranslation() | ibeadmin:'sync'}} 
					{{ INDRA_getArrivalTerminal() | ibeadmin:'sync' }}
				</div>
				<div *ngIf="!INDRA_hasArrivalTerminal()" class="flight-gate"><br></div>
			</div>
			
        </div>
		
		<div class="neo-info" *ngIf="INDRA_hasNeoPlane()">
			<app-svg class="neo-icon" svg="sprite.svg#{{ INDRA_neoIconName() }}" [alt]="'NEO logo'"></app-svg>
			<ul class="simple-list">
				<li *ngIf="hasWifiOnBoard">
					<app-svg class="icon" svg="icons.svg#digital_universe--wifi" aria-hidden="true" [alt]="'Wifi on board icon'">
					</app-svg>
					{{INDRA_getTextTranslation('wifiOnBoard') | ibeadmin:'sync'}}
				</li>
				<li>
					<app-svg class="icon" svg="icons.svg#plane_related--silent-cabin" aria-hidden="true" [alt]="'Silent cabin icon'"></app-svg>
					{{INDRA_getTextTranslation('quietCabin') | ibeadmin:'sync'}}
				</li>
				<li>
					<app-svg class="icon" svg="icons.svg#plane_related--eco-friendly" aria-hidden="true" [alt]="'Eco friendly icon'"></app-svg>
					{{INDRA_getTextTranslation('lowCarbonEmission') | ibeadmin:'sync'}}
				</li>
			</ul>
		</div>
		
		<div *ngIf="apiHasError">
			{{INDRA_getTextTranslation('apiError') | ibeadmin:'sync'}}
		</div>
		
		<div class="warning-banner">
			<app-svg class="warning-icon" svg="icons.svg#general--information" aria-hidden="true" [alt]="'Warning icon'"></app-svg> 
			{{ INDRA_getTextTranslation('airCraftModelMay') | ibeadmin:'sync' }}
        </div>
		
		<div class="info-disclosures" *ngIf="ANACInfo.length > 0">
			<h2>{{INDRA_getTextTranslation('delayAndCancelInfo','title') | ibeadmin:'sync'}}</h2>
			<div>{{INDRA_getTextTranslation('sourceAnac') | ibeadmin:'sync'}}, {{'dates.text.' + anacMonth | ibeadmin | async}} {{anacYear}}</div>
			<div class="flight-airport" *ngFor="let info of ANACInfo">
				<ul class="simple-list" *ngIf="info.cancelations">
					<li>{{info.from}} - {{info.to}}</li>
					<li *ngIf="info.cancelations">
						{{info.cancelations}}{{INDRA_getTextTranslation('delayAndCancelInfo1','listItem') | ibeadmin:'sync'}}
					</li>
					<li *ngIf="info['delays-over-30']">
						{{info['delays-over-30']}}{{INDRA_getTextTranslation('delayAndCancelInfo2','listItem') | ibeadmin:'sync'}}
					</li>
					<li *ngIf="info['delays-over-60']">
						{{info['delays-over-60']}}{{INDRA_getTextTranslation('delayAndCancelInfo3','listItem') | ibeadmin:'sync'}}
					</li>
				</ul>
				<ul class="bullet-list">
					<li>{{INDRA_getTextTranslation('delayAndCancelInfo4','listItem') | ibeadmin:'sync'}}</li>
					<li>{{INDRA_getTextTranslation('delayAndCancelInfo5','listItem') | ibeadmin:'sync'}}</li>
					<li>{{INDRA_getTextTranslation('delayAndCancelInfo6','listItem') | ibeadmin:'sync'}}</li>
					<li>{{INDRA_getTextTranslation('delayAndCancelInfo7','listItem') | ibeadmin:'sync'}}</li>
				</ul>
			</div>
		</div>
		
		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					attr.aria-label="{{INDRA_getTextTranslation('closeDialog', 'label') | ibeadmin:'sync'}}" 
					(click)="INDRA_handleClose()"
					href="javascript:;" 
					role="button">
					{{INDRA_getTextTranslation('closeWindow') | ibeadmin:'sync'}}
					
				</a>
			</div>
		</div>
	</div>
</div>
